import { chakra } from '@plurall/elo-v3';

import { dashboardEmptyStateRecipe } from './DashboardEmptyState.recipe';

export const DashboardEmptyStateFactory = chakra('div', dashboardEmptyStateRecipe);
